// extracted by mini-css-extract-plugin
module.exports = {"root":"breadcrumbs_root__YNyrW"};